export const PRODUCT_NAME = 'activities'
export const EXCURSION = 'excursion'
export const ACTIVITY = 'activity'
